import api from "./api";
import { toast } from "react-toastify";

class UserService {
  async searchUser(q) {
    try {
      const response = await api
        .get("/users/search/?query=" + q)
        .then((res) => res.data);
      if (response.success) {
        const users = response.response;
        const result = users.map((user) => {
          user.id = user.kapid_user_id;
          user.label = `${user.full_name} (${user.kapid_user_id})`;
          return user;
        });
        return result;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return [];
    }
  }

  async addUser(data) {
    try {
      const response = await api
        .post("/users/add/", data)
        .then((res) => res.data);
      if (response.success) {
        const user = response.response;
        return user;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
}
const userService = new UserService();

export default userService;
